var App = App || {};

(function (ns, $) {

    var showThesaurusTermViewAllModal = function (viewAll) {
        $.ajax({
            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/GSW/GeoRefThesaurusTermViewAll/ThesaurusTermViewAllPopup',
            cache: false,
            data: {
                gbosId: viewAll.data('gbosid'),
                gbosContainerId: viewAll.data('gboscontainerid')
            },
            dataType: 'html',
            success: function (data) {
                $('.geoRefTermViewAll').html(data).promise().done(function () {
                    var geoRefTermViewAllModal = $('.geoRefTermViewAllModal');
                    geoRefTermViewAllModal.addClass('open');
                    $('body').addClass('on-canvas');
                });
            }
        });
    };

    var showThesaurusTermViewAll = function () {
        $('.thesaurus-term__view-all').on('click', function () {
            showThesaurusTermViewAllModal($(this));
        });
    };

    ns.init = function () {
        showThesaurusTermViewAll();
    };

})(App.ThesaurusTermJS = App.ThesaurusTermJS || {}, jQuery);

(function ($, undefined) {

    // Document Ready Event: DOM fully loaded
    $(document).ready(function () {
    	App.ThesaurusTermJS.init(); // init general JS module for site
    });
})(jQuery);